import { render } from "./DeputyManagerList.vue?vue&type=template&id=71c850d5&scoped=true"
import script from "./DeputyManagerList.vue?vue&type=script&lang=js"
export * from "./DeputyManagerList.vue?vue&type=script&lang=js"

import "./DeputyManagerList.vue?vue&type=style&index=0&id=71c850d5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c850d5"]])

export default __exports__